import React, { useState, useEffect, useRef } from 'react';
import { EditEmojiImage } from '../../../../redux/slice/SurveySlice/ImageStoreSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { getPagesImageStore, postEmoji } from '../../../../services/ApiServices';
import Error from '../../../../screen/Error/Error';
import { EditQuestionsFirstEmojiUrl, EditQuestionsSecondEmojiUrl } from '../../../../redux/slice/SurveySlice/SurveySlice';
import { FaArrowLeft, FaArrowRight, FaPlus } from "react-icons/fa";
import { toast } from 'react-toastify';

const EmojiSelector = ({ isFirst }) => {
    // State'ler
    const [selectedChoice, setSelectedChoice] = useState(null);  // Seçilen emoji
    const [emojiOptions, setEmojiOptions] = useState([]);  // Veritabanından alınan emoji verileri
    const [paginatedEmojis, setPaginatedEmojis] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal'ın açık olup olmadığı
    const [isAnimating, setIsAnimating] = useState(false);  // Animasyon durumu
    const [selectedImage, setSelectedImage] = useState(null);  // Yeni emoji için seçilen dosya
    const [isUploading, setIsUploading] = useState(false);  // Yükleme durumu
    const [previewUrl, setPreviewUrl] = useState(null); // Resim önizlemesi
    const [imageSuccess, setImageSuccess] = useState(false);
    const dispatch = useDispatch();
    const Survey = useSelector((state) => state.Survey);
    const fileInputRef = useRef(null);
    const [isUploadSuccess, setIsUploadSuccess] = useState(false);

    function ChangeFirstEmoji(value) {
        dispatch(EditQuestionsFirstEmojiUrl(value));
    }
    function ChangeSecondEmoji(value) {
        dispatch(EditQuestionsSecondEmojiUrl(value));
    }
    // Dosya seçildiğinde çalışacak fonksiyon
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
            setSelectedImage(file);
            const fileUrl = URL.createObjectURL(file);
            setPreviewUrl(fileUrl);  // Dosya seçildiğinde önizleme oluşturuluyor
        } else {
            toast.error('Lütfen sadece JPG veya PNG dosyası yükleyin.');
        }
    };

    const mutation = useMutation(postEmoji, {
        onSuccess: (value) => {
            console.log("postvalue:", value?.data?.emojiPath);
            if (isFirst === true) {
                ChangeFirstEmoji(value?.data?.emojiPath);
            }
            else {
                ChangeSecondEmoji(value?.data?.emojiPath);
            }
            setImageSuccess(true);
            setTimeout(() => {
                setIsUploading(false);
                setIsUploadSuccess(true);
                if (isFirst)
                    toast.success("Evet Emojisi Yükleme Başarılı.");

                else
                    toast.success("Hayır Emojisi Yükleme Başarılı.");
            }, 1000);
        },
        onError: (error) => {
            return <Error error={error.message} code={error.request.status} />;
        },
    });

    const handleUpload = async () => {
        if (!selectedImage) {
            toast.error("Lütfen bir emoji dosyası seçin.");
            return;
        }

        setIsUploading(true);
        console.log("selectedImage", selectedImage);

        mutation.mutate(selectedImage);
    };



    return (
        <div className="flex justify-center flex-col items-center mr-5 ml-5 border-2 border-gray-300 rounded-lg py-5 px-6">
        <div className="mt-3 mb-3 w-full max-w-md">
            <h4 className="text-lg text-gray-600 mb-2">
                {isFirst ? "Evet, Emojisi Yükle" : "Hayır, Emojisi Yükle"}
            </h4>
            <hr className="border-t-2 border-gray-300 mb-4" />
            
            {!isUploadSuccess ? (
                <label
                    htmlFor={isFirst ? "first-file-upload" : "second-file-upload"}
                    className="flex justify-center mb-5 items-center w-full px-4 py-3 text-sm text-gray-700 bg-white border-2 border-gray-300 rounded-lg shadow-sm cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                >
                    <div className="flex items-center space-x-2 text-gray-600">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4v12m0 0l-3-3m3 3l3-3"
                            />
                        </svg>
                        <span className="text-sm font-medium">Emoji Seçin</span>
                    </div>
                    <input
                        id={isFirst ? "first-file-upload" : "second-file-upload"}
                        type="file"
                        accept="image/jpeg,image/png"
                        onChange={handleFileChange}
                        className="hidden"
                        disabled={isUploading}
                    />
                </label>
            ) : ""}
            
            {previewUrl && (
                <div className="mb-4 flex justify-center relative w-full max-w-xs mx-auto">
                    <img
                        src={previewUrl}
                        alt="Preview"
                        className="w-full h-36 object-contain rounded-lg border-4 border-gray-200 shadow-lg transition-all transform scale-100 hover:scale-105 duration-300"
                    />
                    {/* Dosya temizleme butonu */}
                    <button
                        type="button"
                        onClick={() => {
                            setIsUploadSuccess(false);
                            setPreviewUrl(null);
                            fileInputRef.current.value = '';
                        }}
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold border-2 border-white hover:bg-red-600 transition-all duration-300 transform translate-x-1/2 -translate-y-1/2"
                    >
                        X
                    </button>
                </div>
            )}
            
            {!isUploadSuccess ? (
                <button
                    onClick={handleUpload}
                    className={`bg-indigo-500 text-white py-2 px-6 rounded-md w-full transition-all ${isUploading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-indigo-600'}`}
                    disabled={isUploading}
                >
                    {isUploading ? 'Yükleniyor...' : 'Yükle'}
                </button>
            ) : ""}
        </div>
    </div>
    



    );
};

export default EmojiSelector;
